<template>
	<v-app id="app">
		<template v-if="$route.path != '/calendar'">
			<v-navigation-drawer
				v-if="$store.getters.isAuthenticated"
				v-model="drawer"
				fixed 
				floating
				clipped
				width="250"
				class="grey lighten-5"
				app>
				<v-toolbar flat class="transparent">
					<v-list dense class="pa-0 pl-2">
						<v-list-tile avatar ripple :to="{path: '/profile'}" class="list-avatar">
							<v-list-tile-avatar v-if="!$store.getters.getProfile.avatar">
								<v-icon x-large>account_circle</v-icon>
							</v-list-tile-avatar>
								<v-avatar v-else
									class="mr-2 custom-avatar"
									:size="40"
									:style="{'background-image': 'url(' + $store.getters.getProfile.avatar + ')'}">
								</v-avatar>
							<v-list-tile-content>
								<v-list-tile-title>{{ $store.getters.getProfile.name}}</v-list-tile-title>
								<v-list-tile-sub-title>{{ $store.getters.getProfile.email}}</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-toolbar>

				<v-list dense class="grey lighten-5 pl-2">
					<template v-for="(item, i) in items">
						<v-divider v-if="item.divider" :key="i" dark class="my-2"></v-divider>
						<v-list-tile v-else :key="i" :exact="item.exact" :to="{path: '/'+item.route}" :disabled="item.disabled" ripple>
							<v-list-tile-action>
								<v-icon color="grey darken-2">{{ item.icon }}</v-icon>
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title class="grey--text text--darken-3">{{ item.text }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>
					<v-list-tile ripple @click="$store.dispatch('AUTH_LOGOUT')">
					<v-list-tile-action>
						<v-icon color="red">exit_to_app</v-icon>
					</v-list-tile-action>
					<v-list-tile-title class="red--text">Esci</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-navigation-drawer>
			<v-toolbar
				color="secondary"
				fixed
				dark
				app
				clipped-left
				v-if="$store.getters.isAuthenticated">
				<v-toolbar-side-icon @click.native="drawer = !drawer"></v-toolbar-side-icon>
				<span>
					<span class="title font-weight-light ml-3">Simona</span>
					<span class="title">&amp;</span>
					<span class="title font-weight-light">Simona</span>
				</span>

				<v-spacer></v-spacer>
				<profile-menu></profile-menu>
			</v-toolbar>
			<v-fade-transition>
				<centered-loader v-show="$store.getters.progress" :size="50" color="primary" ></centered-loader>
			</v-fade-transition>

			<v-content>
				<v-slide-y-reverse-transition>
					<v-container
						px-2
						pt-0
						fluid
						class="grey lighten-5"
						:class="{'fill-height': $route.path == '/login'}">
						<router-view :key="$route.fullPath"></router-view>
					</v-container>
				</v-slide-y-reverse-transition>
			</v-content>

		</template>

			<v-slide-y-reverse-transition v-else>
				<router-view :key="$route.fullPath"></router-view>
			</v-slide-y-reverse-transition>

		<v-snackbar
			:timeout="$store.getters.snackbar.timeout"
			:color="$store.getters.snackbar.color"
			v-model="snackbarValue">
      		<span class="fw500">{{ $store.getters.snackbar.text }}</span>
			<v-btn
				dark
				flat
				@click.native="$store.commit('setSnackbar', {timeout: 6000, text: '', value: false, color: ''})">Chiudi
			</v-btn>
    	</v-snackbar>
  	</v-app>
</template>

<script>
import ProfileMenu from '@/components/ProfileMenu'
import { mapGetters } from 'vuex'
import CenteredLoader from '@/components/CenteredLoader'

export default {
	components: {
		ProfileMenu,
		CenteredLoader
	},
	data() {
		return {
			drawer: null,
			items: [
				{ divider: true },
				{ icon: 'dashboard', text: 'Dashboard', route: 'dashboard' },
				{ icon: 'people', text: 'Clienti', route: 'customers' },
				{ icon: 'local_offer', text: 'Trattamenti', route: 'products' },
				{ icon: 'card_membership', text: 'Carte Fedeltà', route: 'fidelitycards'},
				{ icon: 'event', text: 'Calendario', route: 'calendar'},
				{ icon: 'people_outline', text: 'Utenti', route: 'users' },
				{ icon: 'bar_chart', text: 'Statistiche', route: 'statistics'},
				{ divider: true },
				{ icon: 'settings', text: 'Impostazioni', route: 'settings' }
			]
		}
	},

	computed: {
		...mapGetters(['status']),

		snackbarValue: {
			get() {
				return this.$store.getters.snackbar.value
			},
			set(newValue) {
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: '',
					value: newValue,
					color: ''
				})
			}
		}
	},

	created() {
		if (this.$store.getters.isAuthenticated) {
			this.$store.dispatch('USER_REQUEST').then(setTimeout(() => {
				this.drawer = this.$vuetify.breakpoint.mdAndUp
			}, 1000))
		}
	}
}
</script>
<style>


.v-label {
  font-size: 14px !important;
}

.list-avatar > a {
  padding-left: 8px !important;
}
</style>
